import { render } from "./EndGameBuddy4.vue?vue&type=template&id=563a500a&scoped=true"
import script from "./EndGameBuddy4.vue?vue&type=script&lang=js"
export * from "./EndGameBuddy4.vue?vue&type=script&lang=js"

import "./EndGameBuddy4.vue?vue&type=style&index=0&id=563a500a&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563a500a"]])

export default __exports__